import {
  LOGINUSER,
  GET_PATIENTS,
  DELETE_DOCTOR,
  DELETE_PATIENT,
  DELETE_OPTICIAN,
  GET_NEW_USERS,
  VERIFY_LICENSE,
  DELETE_NEW_USER,
  GET_ACTIVE_USERS,
  GET_DEACTIVE_USERS,
  UPDATE_DEACTIVE_USERS,
  CREATE_USER,
  PERMANENT_DELETE_USER,
} from "../type";
import { InsertData } from "../../Hooks/useInsertData";
import { useGetDataToken } from "../../Hooks/useGetData";
import DeleteData from "../../Hooks/useDeleteData";
import { updateDataWithToken } from "../../Hooks/useUpdateData";

export const LoginUser = (MYdata) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/v1/auth/login`, MYdata);

    dispatch({
      type: LOGINUSER,
      payload: response.data,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: LOGINUSER,
      payload: e.response,
    });
  }
};

export const getActiveUsers = (limit, keyword) => async (dispatch) => {
  try {
    const response = await useGetDataToken(
      `/api/v1/users?limit=${limit}&keyword=${keyword}`,
    );

    dispatch({
      type: GET_ACTIVE_USERS,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: GET_ACTIVE_USERS,
      payload: "Error " + e,
    });
  }
};

export const getNewUsers = (keyword) => async (dispatch) => {
  try {
    const response = await useGetDataToken(
      `/api/v1/users/new-users?keyword=${keyword}`,
    );

    dispatch({
      type: GET_NEW_USERS,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: GET_NEW_USERS,
      payload: "Error " + e,
    });
  }
};

export const getNewUsersPage = (page) => async (dispatch) => {
  try {
    const response = await useGetDataToken(
      `/api/v1/users/new-users?page=${page}`,
    );

    dispatch({
      type: GET_NEW_USERS,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: GET_NEW_USERS,
      payload: "Error " + e,
    });
  }
};
export const getActiveUserPage = (page) => async (dispatch) => {
  try {
    const response = await useGetDataToken(
      `/api/v1/users?limit=10&page=${page}`,
    );

    dispatch({
      type: GET_ACTIVE_USERS,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: GET_ACTIVE_USERS,
      payload: "Error " + e,
    });
  }
};
export const getDeactiveUsers = (limit, keyword) => async (dispatch) => {
  try {
    const response = await useGetDataToken(
      `/api/v1/users/deactivated?limit=${limit}&keyword=${keyword}`,
    );

    dispatch({
      type: GET_DEACTIVE_USERS,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: GET_DEACTIVE_USERS,
      payload: "Error " + e,
    });
  }
};
export const getDeactiveUserPages = (page) => async (dispatch) => {
  try {
    const response = await useGetDataToken(
      `/api/v1/users/deactivated?limit=10&page=${page}`,
    );

    dispatch({
      type: GET_DEACTIVE_USERS,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: GET_DEACTIVE_USERS,
      payload: "Error " + e,
    });
  }
};
export const getAllPatient = (limit, keyword) => async (dispatch) => {
  try {
    const response = await useGetDataToken(
      `/api/v1/patient?limit=${limit}&keyword=${keyword}`,
    );

    dispatch({
      type: GET_PATIENTS,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: GET_PATIENTS,
      payload: "Error " + e,
    });
  }
};
export const getPatientPages = (page) => async (dispatch) => {
  try {
    const response = await useGetDataToken(
      `/api/v1/patient?limit=10&page=${page}`,
    );

    dispatch({
      type: GET_PATIENTS,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: GET_PATIENTS,
      payload: "Error " + e,
    });
  }
};

export const deleteSpecificDoctor = (id) => async (dispatch) => {
  try {
    const response = await DeleteData(`/api/v1/users/doctor/${id}`);

    dispatch({
      type: DELETE_DOCTOR,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: DELETE_DOCTOR,
      payload: e.response,
    });
  }
};
export const deleteNewUser = (id) => async (dispatch) => {
  try {
    const response = await DeleteData(`/api/v1/users/${id}`);

    dispatch({
      type: DELETE_NEW_USER,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: DELETE_NEW_USER,
      payload: e.response,
    });
  }
};

export const deleteSpecificpatient = (id) => async (dispatch) => {
  try {
    const response = await DeleteData(`/api/v1/patient/${id}`);

    dispatch({
      type: DELETE_PATIENT,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: DELETE_PATIENT,
      payload: e.response,
    });
  }
};
export const deleteSpecificoptician = (id) => async (dispatch) => {
  try {
    const response = await DeleteData(`/api/v1/user/optician/${id}`);

    dispatch({
      type: DELETE_OPTICIAN,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: DELETE_OPTICIAN,
      payload: e.response,
    });
  }
};

export const UpdateDeactiveUsers = (id, body) => async (dispatch) => {
  try {
    const response = await updateDataWithToken(
      `/api/v1/users/${id}/reactivate`,
      body,
    );
    dispatch({
      type: UPDATE_DEACTIVE_USERS,
      payload: response,
      loading: true,
    });
    return response;
  } catch (e) {
    dispatch({
      type: UPDATE_DEACTIVE_USERS,
      payload: e.response,
    });
    return e.response;
  }
};

export const createUser = (body) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/v1/users`, body); // ← InsertData مش WithImage
    dispatch({
      type: CREATE_USER,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: CREATE_USER,
      payload: e.response,
    });
  }
};

export const verify_license = (body) => async (dispatch) => {
  try {
    const response = await updateDataWithToken(
      `/api/v1/auth/license-verified`,
      body,
    );
    dispatch({
      type: VERIFY_LICENSE,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: VERIFY_LICENSE,
      payload: e.response,
    });
  }
};

export const permanentlyDeleteUser = (id) => async (dispatch) => {
  try {
    const response = await DeleteData(`/api/v1/users/${id}/permanent`);

    dispatch({
      type: PERMANENT_DELETE_USER,
      payload: response,
    });
    return response; // ← ضف هذا السطر لترجيع النتيجة للمكون مباشرة
  } catch (e) {
    dispatch({
      type: PERMANENT_DELETE_USER,
      payload: e.response,
    });
    return e.response; // ← ضف هذا السطر في حالة الخطأ أيضاً
  }
};
